import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Provider } from '@angular/core';

import { AuthenticationInterceptor } from '@app/modules/authentication/mocks/interceptors/authentication.mock';
import { ProfileInterceptor } from '@app/modules/profile/mocks/interceptors/profile.mock';
import { CustomersInterceptor } from '@app/modules/dashboard/mocks/customers.mock';
import { InvoicesInterceptor } from '@app/modules/invoices/mocks/invoices.mock';
import { ProceedsInterceptor } from '@app/modules/dashboard/mocks/proceeds.mock';
import { UsersInterceptor } from '@app/modules/dashboard/mocks/users.mock';
import { CardTransactionsInterceptor } from '@app/modules/card-transactions/mocks/card-transactions.mock';
import { CardRequestsInterceptor } from '@app/modules/card-requests/mocks/card-requests.mock';
import { CardSettingsInterceptor } from '@app/modules/card-settings/mocks/card-settings.mock';
import { CardSettingsHistoryInterceptor } from '@app/modules/card-settings-history/mocks/card-settings-history.mock';

import { environment } from 'environments/environment';

const mockProviders: Provider[] = [];

if (environment.mocks.auth) {
  mockProviders.push(
    {provide: HTTP_INTERCEPTORS, useClass: AuthenticationInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ProfileInterceptor, multi: true}
  );
}

if (environment.mocks.customers) {
  mockProviders.push(
    {provide: HTTP_INTERCEPTORS, useClass: CustomersInterceptor, multi: true}
  );
}

if (environment.mocks.invoices) {
  mockProviders.push(
    {provide: HTTP_INTERCEPTORS, useClass: InvoicesInterceptor, multi: true}
  );
}

if (environment.mocks.proceeds) {
  mockProviders.push(
    {provide: HTTP_INTERCEPTORS, useClass: ProceedsInterceptor, multi: true}
  );
}

if (environment.mocks.users) {
  mockProviders.push(
    {provide: HTTP_INTERCEPTORS, useClass: UsersInterceptor, multi: true}
  );
}

if (environment.mocks.cards) {
  mockProviders.push(
    {provide: HTTP_INTERCEPTORS, useClass: CardTransactionsInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: CardRequestsInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: CardSettingsInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: CardSettingsHistoryInterceptor, multi: true}
  );
}

@NgModule()
export class MockInterceptorConfig {
  static forRoot(): ModuleWithProviders<MockInterceptorConfig> {
    return {
      ngModule: MockInterceptorConfig,
      providers: mockProviders
    };
  }
}
